var _excluded = ["onValueChange", "currency", "integerLimit", "decimalLimit", "allowNegativeValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from 'react';
import CurrencyInput from 'react-currency-input-field';
import { getCurrencyDetails } from '../../../utils/currency-utils';
import { getValidValue, intlConfigByCurrency } from './currencyInputHelper';
/**
 * @private For internal use only
 */

import { jsx as _jsx } from "react/jsx-runtime";
export var _CurrencyInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    onValueChange,
    currency,
    integerLimit = 8,
    decimalLimit = 2,
    allowNegativeValue = true
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var intlConfig = intlConfigByCurrency[currency];
  var {
    sign
  } = getCurrencyDetails(currency);

  function handleChange(value) {
    var validValue = getValidValue(value, integerLimit, decimalLimit);
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(validValue);
  }

  var value = getValidValue(props.value, integerLimit, decimalLimit);
  return /*#__PURE__*/_jsx(CurrencyInput, _objectSpread(_objectSpread({}, props), {}, {
    transformRawValue: rawValue => allowNegativeValue ? rawValue : rawValue.replace('-', ''),
    ref: ref,
    value: value,
    prefix: sign,
    intlConfig: intlConfig,
    allowNegativeValue: allowNegativeValue,
    onValueChange: handleChange,
    decimalsLimit: decimalLimit
  }));
});
_CurrencyInput.displayName = '_CurrencyInput';
//# sourceMappingURL=_CurrencyInput.js.map